export enum MenuTreeButtonAction {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}
